export default __webpack_public_path__ + "static/media/send.e888cd16.svg";